/**
 * NaamDarbar — Suspense placeholder for route chunk loading.
 *
 * Intentionally renders an empty layout slot (no shape, no shimmer). Each
 * page owns its own data-loading skeleton tuned to its real layout — if we
 * render a *generic* skeleton here, users see a wrong-shaped placeholder
 * for ~100-300ms before it swaps to the page's correct skeleton, which
 * looks broken (two layout shifts in a row).
 *
 * The Suspense boundary lives inside <Layout>, so the navbar / footer stay
 * mounted while this empty slot is on screen — no full-page blank flash.
 * Combined with hover-prefetch (PrefetchLink), the chunk is usually already
 * loaded by the time the click registers, so this fallback rarely renders
 * for more than a frame.
 */

export default function PageSkeleton() {
  // Reserve vertical space so the footer doesn't jump up momentarily.
  return <div className="min-h-[60vh]" aria-hidden />;
}

